<template>
  <div class="memorial">
    <!-- Hero -->
    <section class="hero">
      <div class="hero-content">
        <h1>宠星纪念馆</h1>
        <p>为回到母星的毛孩子建立永恒档案</p>
      </div>
    </section>

    <!-- 宠物类别 -->
    <section class="categories">
      <div class="container">
        <h2 class="section-title">宠物类别</h2>
        <div class="categories-grid">
          <div class="category-card">
            <div class="category-icon">🐱</div>
            <h3>喵星馆</h3>
            <p>猫咪专属纪念馆</p>
          </div>
          <div class="category-card">
            <div class="category-icon">🐕</div>
            <h3>汪星馆</h3>
            <p>狗狗专属纪念馆</p>
          </div>
          <div class="category-card">
            <div class="category-icon">🐰</div>
            <h3>蹦星馆</h3>
            <p>兔子专属纪念馆</p>
          </div>
          <div class="category-card">
            <div class="category-icon">🐹</div>
            <h3>吱星馆</h3>
            <p>仓鼠专属纪念馆</p>
          </div>
          <div class="category-card">
            <div class="category-icon">🦜</div>
            <h3>啾星馆</h3>
            <p>鸟类专属纪念馆</p>
          </div>
          <div class="category-card">
            <div class="category-icon">✨</div>
            <h3>其他馆</h3>
            <p>更多宠物类别</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务介绍 -->
    <section class="features">
      <div class="container">
        <div class="features-content">
          <div class="feature-text">
            <h2>纪念馆服务</h2>
            <ul class="feature-list">
              <li>
                <span class="feature-icon">📖</span>
                <div>
                  <h4>专属纪念页</h4>
                  <p>为每只宠物创建独立的纪念页面</p>
                </div>
              </li>
              <li>
                <span class="feature-icon">📷</span>
                <div>
                  <h4>相册管理</h4>
                  <p>上传和保存珍贵照片与视频</p>
                </div>
              </li>
              <li>
                <span class="feature-icon">✍️</span>
                <div>
                  <h4>纪念文章</h4>
                  <p>记录与宠物的美好回忆</p>
                </div>
              </li>
              <li>
                <span class="feature-icon">💐</span>
                <div>
                  <h4>在线祭奠</h4>
                  <p>为宠物送上虚拟鲜花和祝福</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="feature-image">
            <div class="image-placeholder">🌟</div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta">
      <div class="container">
        <h2>为您的爱宠建立纪念馆</h2>
        <p>永久保存珍贵回忆，让爱永远延续</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Memorial'
}
</script>

<style scoped>
.memorial {
  padding-top: 70px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero - 星空渐变 */
.hero {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  padding: 120px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 70%, rgba(123, 104, 238, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 30%, rgba(230, 168, 215, 0.1) 0%, transparent 40%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
  border-radius: 50%;
  box-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero h1 {
  font-size: 3rem;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 700;
  text-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.85);
}

/* Section Title */
.section-title {
  text-align: center;
  font-size: 2.2rem;
  color: #302b63;
  margin-bottom: 50px;
  font-weight: 600;
}

/* Categories */
.categories {
  padding: 100px 0;
  background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 25px;
}

.category-card {
  text-align: center;
  padding: 40px 20px;
  background: #fff;
  border-radius: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(123, 104, 238, 0.1);
  box-shadow: 0 4px 20px rgba(48, 43, 99, 0.05);
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(123, 104, 238, 0.15);
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  border-color: transparent;
}

.category-card:hover h3,
.category-card:hover p {
  color: #fff;
}

.category-icon {
  font-size: 3rem;
  margin-bottom: 15px;
}

.category-card h3 {
  font-size: 1.2rem;
  color: #302b63;
  margin-bottom: 8px;
  transition: color 0.3s ease;
  font-weight: 600;
}

.category-card p {
  font-size: 0.9rem;
  color: #888;
  transition: color 0.3s ease;
}

/* Features */
.features {
  padding: 100px 0;
  background: linear-gradient(180deg, #f0edff 0%, #f8f7ff 100%);
}

.features-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.feature-text h2 {
  font-size: 2.2rem;
  color: #302b63;
  margin-bottom: 40px;
  font-weight: 600;
}

.feature-list {
  list-style: none;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 30px;
}

.feature-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.feature-list h4 {
  font-size: 1.2rem;
  color: #302b63;
  margin-bottom: 5px;
}

.feature-list p {
  color: #666;
  line-height: 1.6;
}

.feature-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-placeholder {
  width: 350px;
  height: 350px;
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8rem;
  box-shadow: 0 20px 60px rgba(123, 104, 238, 0.3);
}

/* CTA - 深空背景 */
.cta {
  padding: 100px 0;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 50% 50%, rgba(123, 104, 238, 0.1) 0%, transparent 60%);
  pointer-events: none;
}

.cta h2 {
  font-size: 2.2rem;
  color: #fff;
  margin-bottom: 15px;
  font-weight: 600;
  position: relative;
  z-index: 1;
}

.cta p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  margin-bottom: 35px;
  position: relative;
  z-index: 1;
}

.btn-primary {
  padding: 15px 50px;
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(123, 104, 238, 0.4);
  position: relative;
  z-index: 1;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(123, 104, 238, 0.5);
}

@media (max-width: 968px) {
  .categories-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .features-content {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .feature-image {
    order: -1;
  }

  .image-placeholder {
    width: 250px;
    height: 250px;
    font-size: 5rem;
  }
}

@media (max-width: 600px) {
  .hero h1 {
    font-size: 2.2rem;
  }

  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .category-card {
    padding: 30px 15px;
  }

  .section-title {
    font-size: 1.8rem;
  }
}
</style>
